import React, { createContext, useContext } from 'react';

const LanguageContext = createContext({});

export const i18nProvider = ({ children, value }) => {
    return <LanguageContext.Provider value={ value }>
        { children }
    </LanguageContext.Provider>
}

export default i18nProvider

export const useI18n = () => useContext(LanguageContext)
